{{ struc.message | translate}}
<mat-form-field style="margin-top: 12px; width: 100%;">
    <input matInput [formControl]="newName" [placeholder]="'New name' | translate">
</mat-form-field>